import { defineStore } from 'pinia'
export const useCommonStore = defineStore('useCommonStore', {
  state: (): any => {
    return {
      routerInclude: [],
      activeTabbar: '',
      phoneArea: [],
    }
  },
  actions: {
    setActiveTabbar(activeTabbar: string) {
      this.activeTabbar = activeTabbar
    },
    addRouterInclude(routerInclude: string) {
      this.routerInclude.push(routerInclude)
    },
    removeInclude(routerInclude: string) {
      // 删除所有包含routerInclude的元素
      this.routerInclude = this.routerInclude.filter((item: string) => item !== routerInclude)
      setTimeout(() => {
        this.routerInclude.push(routerInclude)
      }, 1000)
      //   let index = this.routerInclude.indexOf(routerInclude)
      //   if (index > -1) {
      //     this.routerInclude.splice(index, 1)
      //   }
    },
    resetInclude() {
      this.routerInclude = []
    },
    // getPhoneArea() {
    //     userCommonMetas({ types: 'phoneArea' }).then(res => {
    //         if (res.code === 0) {
    //             this.phoneArea = res.data.phoneArea
    //         }
    //     })
    // },
  },
  getters: {},
})
